import { gql } from "@apollo/client";
import { VENUE_FRAGMENT } from "venue/fragments";
import { USER_FRAGMENT } from "users/fragments";

import { VENUE_USER_FRAGMENT } from "./venueUser";

export const VENUE_USER_WITH_RELATIONS_FRAGMENT = gql`
  ${VENUE_USER_FRAGMENT}
  ${VENUE_FRAGMENT}
  ${USER_FRAGMENT}
  fragment VenueUserWithRelations on VenueUser {
    ...VenueUser
    venue @include(if: $venueInclude) {
      ...Venue
    }
    user @include(if: $userInclude) {
      ...User
    }
  }
`;
